<template>
  <div class="required reset">
    <div class="logo-wrapper"></div>
    <el-card class="reset-form-layout lg:w-1/3 md:w-1/2">
      <el-form autoComplete="on" class="my-5 mx-5" label-position="left">
        <div class="flex justify-center">
          <el-image style="width: 7.5rem;height: 7.5rem;" :src="baseOSSUrl + '/resetSuccess.png'"></el-image>
        </div>
        <div>
          <h2 class="reset-title my-5">重置成功</h2>
        </div>
        <el-form-item class="mt-10 text-center">
          <el-button style="background-color: #123B7F;border: none;" class="w-full" type="primary"  @click.native.prevent="toRegister()">
            返回登录
          </el-button>
        </el-form-item>
      </el-form>

    </el-card>

  </div>

</template>

<script>
import {
baseOSSUrl
} from '@/utils/oss';
export default {
  name: "resetSuccess",
  data() {
    return {
      baseOSSUrl
    }
  },
  methods:{
    toRegister(){
      this.$router.push({
        path: '/login'
      });
    }
  }
}
</script>

<style scoped>
.reset {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/login_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.reset-title {
  font-size: 1.875rem;
  font-weight: bold;
  color: #333333;
  letter-spacing: 2px;
  text-align: center;
}

.reset-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  /*width: 22.5rem;*/
  margin: 140px auto;
}
</style>